import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { finalize, tap } from 'rxjs';
import { AlliedservicesService } from 'src/app/services/alliedservices.service';
import { FacilitatorserviceService } from 'src/app/services/facilitatorservice.service';
import { Allied } from 'src/app/shared/data/models';
import { SubSink } from 'subsink';
import { ConfirmTransferComponent } from '../confirm-transfer/confirm-transfer.component';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-transfer-facilitator',
  templateUrl: './transfer-facilitator.component.html',
  styleUrls: ['./transfer-facilitator.component.scss']
})
export class TransferFacilitatorComponent implements OnInit, OnDestroy {
  private subs = new SubSink();
  public statusDetail: 'loading' | 'success' | 'error' | 'init' = 'init';
  public organizationList: Allied[] = [];
  public showAnimation: boolean = true;
  public options: AnimationOptions;
  constructor(
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: { facilitatorName: string, facilitatorId: string, action:string },
    private alliedServices: AlliedservicesService,
    private facilitatorService: FacilitatorserviceService,
    private _snackBar: MatSnackBar,
    private trasnlateService: TranslateService,
    private dialogRef: MatDialogRef<TransferFacilitatorComponent>
  ) { 

  };

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  };

  ngOnInit(): void {
    this.getListAllied();
  };

  private getListAllied(): void {
    this.showAnimation = true; // Mostrar loader
    this.subs.sink = this.alliedServices.getListOrganizations('', 1, 1000)
      .pipe(
        tap(() => this.statusDetail = 'success'),
        finalize(() => {
          this.showAnimation = false; // Ocultar loader cuando finaliza la operación
        })
      )
      .subscribe((rta: any) => {
        this.organizationList = rta.find;
      }, error => {
        // Manejo de error (opcional)
        this.showAnimation = false;
      });
  }

  private transferFacilitator(id: string, body: any): void {
    this.facilitatorService.transferFacilitator(id, body).subscribe();
  };

  public save(form: NgForm): void {
    const { organization } = form.value;
    this.confirmTransfer(organization);
  };

  public confirmTransfer(objet: Allied): void {
    let dialog = this.dialog.open(ConfirmTransferComponent, {
      width: '456px',
      height: '218px',
      disableClose:true,
      data: {
        facilitatorName: this.data.facilitatorName,
        organizationName: objet.name_ally
      }
    });
    this.subs.sink = dialog.afterClosed().subscribe((result: boolean) => {
      if (result == true) {
        const body = {
          new_allied: objet._id
        };
        this.transferSucces(body)
        this.dialog.closeAll();
      };
    });
  }

  private transferSucces(body: any): void {
    let change = true;
    this.subs.sink = this.trasnlateService.get(['FACILITATOR.transfer-succes', 'USERS.undo']).subscribe(
      (valor) => {
        const message = valor['FACILITATOR.transfer-succes'];
        const action = valor['USERS.undo'];
        const snackBarRef = this._snackBar.open(message, action, {
          duration: 3000,
          panelClass: 'position-transfer-succes'
        });
        snackBarRef.onAction().subscribe(() => {
          change = false;
        });
        snackBarRef.afterDismissed().subscribe(() => {
          if (change === true) {
            this.transferFacilitator(this.data.facilitatorId, body);
          }
        });
      });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
